// @flow
export { default } from './CheckoutTemplate';



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutTemplate/index.js